import {
  CelebrationNumberInput,
  CelebrationTextInput,
} from "@components/adapters/celebration/Input";
import type {
  InputComponent,
  InputProps,
} from "@components/contracts/Input.types";

const TextInput: React.FC<InputProps> = (props) => (
  <CelebrationTextInput {...props} />
);

const NumberInput: React.FC<InputProps> = (props) => (
  <CelebrationNumberInput {...props} />
);

export const Input: InputComponent = {
  Text: TextInput,
  Number: NumberInput,
};

export type { InputProps };
